export default __webpack_public_path__ + "static/kontakt-93b2e35b5c88ff2ec17b26c90cce3e3c.jpg";